<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="单聊列表">
        <div class="row">
          <div class="flex xs6">
            <va-input
                v-model="nickname"
                placeholder="按用户名搜索"
                @input="search"
                removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs6">
            <va-button flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <div class="flex xs12">
          <va-data-table
            :fields="fields"
            :data="c2cGroupList"
            :loading="loading"
            @page-selected="listC2cGroup"
            api-mode
            :total-pages="totalPage"
          >
            <template slot="createTime" slot-scope="props">
              {{ formatTime(props.rowData.createTime) }}
            </template>

            <template slot="lastMsgTime" slot-scope="props">
              {{ formatTime(props.rowData.lastMsgTime) }}
            </template>

            <template slot="lastMsg" slot-scope="props">
              <template v-if="getPayloadType(props.rowData.lastMsg)==='NONE'">
              </template>
              <template v-if="getPayloadType(props.rowData.lastMsg)==='text'">
                {{ formatPayload(props.rowData.lastMsg) }}
              </template>
              <template v-if="getPayloadType(props.rowData.lastMsg)==='audio'">
                <audio v-bind:src="formatPayload(props.rowData.lastMsg).url"
                       controls="controls"></audio>
              </template>
              <template v-if="getPayloadType(props.rowData.lastMsg)==='image'">
                <va-card
                    overlay
                    :image='formatPayload(props.rowData.lastMsg).url'
                    class="va-card-image"
                    :image-alt="formatPayload(props.rowData.lastMsg).name"
                />
              </template>
              <template v-if="getPayloadType(props.rowData.lastMsg)==='file'">
                <a v-bind:href="formatPayload(props.rowData.lastMsg).url"> {{
                    formatPayload(props.rowData.lastMsg).name
                  }} </a>
              </template>
              <template v-if="getPayloadType(props.rowData.lastMsg)==='video'">
                <video v-bind:src="formatPayload(props.rowData.lastMsg).url"
                       controls="controls" height="200px"></video>
              </template>
            </template>

            <template slot="memberList" slot-scope="props">
              <div
                v-for="v in props.rowData.memberList"
              >
                <va-button color="dark" flat small :to='{path:`/admin/users/updateUser/${v.uid}`}'>
                  {{ formatMember(v) }}
                </va-button>
              </div>
            </template>

            <template slot="actions" slot-scope="props">
              <va-popover message="群聊列表" placement="top">
                <va-button
                    flat
                    small
                    color="gray"
                    icon="fa fa-comments-o"
                    :to="{name:'chat', params:{channelId: props.rowData.groupId}}"
                />
              </va-popover>
            </template>
          </va-data-table>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import groupApi from '../../api/group'
import { dateFormat } from '../../utils/common'
import debounce from "lodash/debounce";

export default {
  data () {
    return {
      message: ['Required field'],
      c2cGroupList: [],
      loading: true,
      next: 0,
      totalCount: 0,
      deleteModal: false,
      deleteGroupId: null,
      pageNumber: 1,
      nickname: null,
      totalPage: null,
      isLibaTeacher: null
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:memberList',
          title: '成员',
          width: '40%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:createTime',
          title: '创建时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:lastMsgTime',
          title: '上次发言时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listC2cGroup()
  },
  methods: {
    formatPayload(payload) {
      if (payload == null) {
        return ""
      }
      let payloadJson = JSON.parse(payload)
      if (payloadJson.hasOwnProperty("text")) {
        return payloadJson.text
      } else if (payloadJson.hasOwnProperty("data")) {
        let data = JSON.parse(payloadJson.data)
        if (payloadJson.hasOwnProperty("description") && payloadJson.description === 'audio') {
          return {
            "url": data.remoteAudioUrl
          }
        }
        return {
          "url": data.url,
          "name": data.name
        }
      }
    },
    getPayloadType(payload) {
      if (payload==null) {
        return "NONE"
      }
      let payloadJson = JSON.parse(payload)
      if (payloadJson.hasOwnProperty("text")) {
        return "text"
      } else if (payloadJson.hasOwnProperty("data")) {
        if (payloadJson.hasOwnProperty("description") && payloadJson.description === 'audio') {
          return payloadJson.description
        }
        let data = JSON.parse(payloadJson.data)
        return data.type
      }
    },
    formatNickname (nickname) {
      if (nickname == null) {
        return ''
      }
      if (nickname.length <= 10) {
        return nickname
      } else {
        return nickname.substr(0, 10) + '...'
      }
    },
    formatMember(member) {
      if (member == null) {
        return ''
      }
      return member.nickname
    },
    formatTime (time) {
      if (time === 0 || time == null) {
        return '未发言'
      }
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    computedColor: function (isLibaTeacher) {
      return this.isLibaTeacher === isLibaTeacher ? 'info' : 'gray'
    },
    switchChatType(isLibaTeacher) {
      this.isLibaTeacher = isLibaTeacher;
      this.listC2cGroup();
    },
    listC2cGroup(pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
      }
      if (this.nickname != null) {
        data.nickname = this.nickname
      }
      groupApi.listC2cGroup(data)
        .then(response => {
          console.log(response)
          this.c2cGroupList = response.c2cGroupList
          this.totalPage = response.totalPage
          this.totalCount = response.totalCount
          this.loading = false
        })
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') { this.nickname = null }
      this.listC2cGroup()
    }, 400),
  },
}

</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
